import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-subnav',
  templateUrl: './users-subnav.component.html',
  styleUrls: ['./users-subnav.component.scss']
})
export class UsersSubnavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
